import React from 'react';

// Styles
import classnames from 'classnames';

import AnalyticsLink from '@components/Analytics/AnalyticsLink';
import styles from './ButtonLinkComponent.module.scss';

// Utils & Helpers
import { getLocalizedContent as l } from '@helpers/languages';

const ButtonLinkComponent = ({ data, language }) => (
  <AnalyticsLink
    className={classnames('button', styles.button)}
    to={data.link['en']}
    gaType="footer"
    gaComponent="footer"
  >
    {l(data.title, language)}
  </AnalyticsLink>
);

export default ButtonLinkComponent;
